import { render, staticRenderFns } from "./BrandTree.vue?vue&type=template&id=33b101fd&scoped=true"
import script from "./BrandTree.vue?vue&type=script&lang=js"
export * from "./BrandTree.vue?vue&type=script&lang=js"
import style0 from "./BrandTree.vue?vue&type=style&index=0&id=33b101fd&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33b101fd",
  null
  
)

export default component.exports